// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SerializedVariant } from './SerializedVariant';
import {
    SerializedVariantFromJSON,
    SerializedVariantFromJSONTyped,
    SerializedVariantToJSON,
    SerializedVariantToJSONTyped,
} from './SerializedVariant';

/**
 * 
 * @export
 * @interface ControlCallResult
 */
export interface ControlCallResult {
    /**
     * 
     * @type {string}
     * @memberof ControlCallResult
     */
    browsePath?: string;
    /**
     * The method output arguments returned by the device
     * @type {Array<SerializedVariant>}
     * @memberof ControlCallResult
     */
    outputArguments?: Array<SerializedVariant>;
}

/**
 * Check if a given object implements the ControlCallResult interface.
 */
export function instanceOfControlCallResult(value: object): value is ControlCallResult {
    return true;
}

export function ControlCallResultFromJSON(json: any): ControlCallResult {
    return ControlCallResultFromJSONTyped(json, false);
}

export function ControlCallResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCallResult {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'] == null ? undefined : json['browsePath'],
        'outputArguments': json['outputArguments'] == null ? undefined : ((json['outputArguments'] as Array<any>).map(SerializedVariantFromJSON)),
    };
}

export function ControlCallResultToJSON(json: any): ControlCallResult {
    return ControlCallResultToJSONTyped(json, false);
}

export function ControlCallResultToJSONTyped(value?: ControlCallResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'outputArguments': value['outputArguments'] == null ? undefined : ((value['outputArguments'] as Array<any>).map(SerializedVariantToJSON)),
    };
}

